export default __webpack_public_path__ + "446b2f72ce491e13d4bab5f6398a2b2c.png";